module.exports = __webpack_public_path__ + "assets/img/projects_jh.14cef387.png";